import { render, staticRenderFns } from "./CollapsePage.vue?vue&type=template&id=4079f6d9&scoped=true&"
import script from "./CollapsePage.vue?vue&type=script&lang=js&"
export * from "./CollapsePage.vue?vue&type=script&lang=js&"
import style0 from "./CollapsePage.vue?vue&type=style&index=0&id=4079f6d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4079f6d9",
  null
  
)

export default component.exports